export default {
  manage_deleteLocation: "Delete Location",
  manage_deleteLocations: "Delete Locations",
  manage_deletedLocation: "Location was deleted successfully",
  manage_deletedLocations: "Locations were deleted successfully",
  manage_deleteManageLocation_confirmationMessage:
    "Are you sure you want to delete the following Locations?",
  manage_deleteManageLocation_transferUnits:
    "Assigned units have been found in the Location(s) being removed. Please select a new Location for these units.",
  manage_deleteManageLocation_toReceive: "Clear Location for Units",
  manage_deleteManageLocation_selectLocation: "Select a Location"
};
